import React from "react";
import { Link } from "react-router-dom";

/**
 * Latest articles list for sidebar (mirrors donor LatestPublications).
 * Uses twentytwentysix layout.
 */
export default function ResourcesLatestSidebar({ articles }) {
  const list = Array.isArray(articles) ? articles.slice(0, 6) : [];

  if (list.length === 0) return null;

  return (
    <div
      className="twentytwentysix-content__mlist-sidebar-facet-group"
      role="navigation"
      aria-label="Latest articles"
    >
      <h2 className="twentytwentysix-content__mlist-sidebar-title">Latest</h2>
      <ul className="twentytwentysix-content__list twentytwentysix-content__list--no-bullets twentytwentysix-content__latest-sidebar-list">
        {list.map((article) => (
          <li key={article.slug} className="twentytwentysix-content__latest-sidebar-item">
            <Link
              to={`/twentytwentysix/resources/${article.slug}`}
              className="twentytwentysix-content__link twentytwentysix-content__latest-sidebar-link"
            >
              {article.title || "Untitled"}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
